import { styled, Typography } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  marginBottom: 96,
  minHeight: '100%',
  paddingBottom: 48,
}));

export const TitlePageStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  margin: '12px 96px',
}));

export const SubtitlePageStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  fontWeight: 500,
  margin: '0 96px 24px 96px',
}));

export const MainStyled = styled('div')(() => ({
  padding: '0 96px',
}));
